import React from 'react'

import { MainContent } from '@campaignhub/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'

import LoggedInUser from '@components/TopBar/components/LoggedInUser'
import Search from '@components/TopBar/components/Search'
import TimeTracker from '@components/TopBar/components/TimeTracker'
import TopBar from '@components/TopBar'

import MainNavigation from '@sections/Production/components/MainNavigation'

import DashboardRoutes from './routes'

const Dashboard = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  return (
    <>

      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        timeTrackerComponent={<TimeTracker />}
        searchComponent={<Search callbacks={{ search: null }} />}
      />

      <MainNavigation />

      <MainContent offset={{ top: TopBar.topBarHeight }}>
        <DashboardRoutes />
      </MainContent>
    </>
  )
}

export default Dashboard
